import {
  FullScreenModalContent as Content,
  FullScreenModalFooter as Footer,
  FullScreenModalHeader as Header,
  FullScreenModalRoot as Root,
  FullScreenModalTitle as Title,
} from './FullScreenModal';
export default { Content, Footer, Header, Root, Title };
